<template>
    <div v-if="plans.length > 1">
        <div v-for="(plan, index) in plans" :key="index">
        <hp5-semantic size-selection="xs">
            <input :id="`input-${plan.name}`" type="radio" name="plan" :value="index" v-model="filterContext.networkIndex" />
            <label :for="`input-${plan.name}`">{{ plan.name }}</label>
        </hp5-semantic>
        </div>
    </div>
</template>
<script setup lang="ts">

    const props = defineProps<{
            plans: Array<{ name: string }>
    }>()

    const { filterContext } = useFCPModel()

</script>

<style scoped>
    label {
        padding-left: 10px;
    }
</style>